import { render, staticRenderFns } from "./KLabeledIcon.vue?vue&type=template&id=56a20d97&scoped=true&"
import script from "./KLabeledIcon.vue?vue&type=script&lang=js&"
export * from "./KLabeledIcon.vue?vue&type=script&lang=js&"
import style0 from "./KLabeledIcon.vue?vue&type=style&index=0&id=56a20d97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a20d97",
  null
  
)

export default component.exports